<script setup>
import { ref, onMounted } from 'vue';
import { deferredPromise } from '/app/utils/promise';

const props = defineProps({
    immediate: {
        type: Boolean,
        default: false,
    },
});

const isOpen = ref(false);
const payload = ref(null);
let deferred = null;

function open(value) {
    isOpen.value = true;
    payload.value = value;
    deferred = deferredPromise();

    return deferred.promise;
}

function close() {
    isOpen.value = false;

    if (deferred) {
        deferred.resolve(payload.value);
        deferred = null;
    }
}

defineExpose({ open, close });

onMounted(() => {
    if (props.immediate) {
        open();
    }
});
</script>

<template>
    <Teleport v-if="isOpen" to="#navbar-notifications">
        <slot :close="close" />
    </Teleport>
</template>
